import React from 'react';
import cn from 'classnames';
import Graphic from '../Graphic';
import sharedStyles from '../WelcomeGuide.module.scss';
import styles from './Intro.module.scss';

export default function Intro({ user, onClick, turnToPage }) {
  const userName = user?.first_name ? ', ' + user?.first_name : '';

  return (
    <div className={sharedStyles.page} onClick={onClick}>
      <div className={styles.openingGraphicContainer}>
        <Graphic className={styles.openingGraphic} />
      </div>
      <div className={cn(sharedStyles.pageContent, sharedStyles.right)}>
        <h2>Welcome to Clay</h2>
        <p>
          We’re thrilled to have you here{userName}! The next few pages are a bespoke guide made
          just for you detailing all the many features in Clay.
        </p>
        <div className={styles.toc}>
          <div className={styles.pageLink} onClick={turnToPage(1)}>
            <h4>Your Community</h4>1
          </div>
          <div className={styles.pageLink} onClick={turnToPage(2)}>
            <h4>Note Taking</h4>2
          </div>
          <div className={styles.pageLink} onClick={turnToPage(3)}>
            <h4>Search</h4>3
          </div>
          <div className={styles.pageLink} onClick={turnToPage(4)}>
            <h4>Home</h4>4
          </div>
        </div>
      </div>
    </div>
  );
}
